<template>
  <path
    d="M9.15 4.153l8.050 8.047-1.697 1.697-6.353-6.35-6.35 6.351-1.697-1.697 8.047-8.048z"
  ></path>
</template>
